import React, { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import MembershipGoodIcon from '@material-ui/icons/VerifiedUser';
import MembershipBadIcon from '@material-ui/icons/Error';
import GroupIcon from '@material-ui/icons/Group';

import useApp from 'app/context/useApp';

const useStyles = makeStyles(theme => ({
    membershipContainer: {
        position: 'relative'
    },
    membershipIconContainer: {
        textAlign: 'center',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    textSuccess: {
        color: theme.palette.success.main
    },
    membershipGoodIcon: {
        width: '30%',
        height: 'auto',
        display: 'inline-block',
        color: theme.palette.success.main
    },
    guestIcon: {
        width: '30%',
        height: 'auto',
        display: 'inline-block',
        color: theme.palette.secondary.main
    },
    membershipBadIcon: {
        width: '30%',
        height: 'auto',
        color: theme.palette.error.main,
        display: 'inline-block'
    },
    bottomLink: {
        marginTop: theme.spacing(3),
        fontWeight: 600
    }
}));

export default function MembershipStatus(props) {

    const { app } = useApp();
    const classes = useStyles();

    const membership = app.user.membership_status;

    return (
        <div className={classes.membershipContainer}>
            <Typography variant="h6">
                {membership.is_member ? "Your Membership" : "Guest Account"}
            </Typography>
            <Divider/>
            {(membership && !membership.is_member) &&
                <Fragment>
                    <div className={classes.membershipIconContainer}>
                        <GroupIcon className={classes.guestIcon}/>
                    </div>
                    <Typography variant="subtitle2" component="h3" align="center" gutterBottom>
                        You are using a guest account.
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom color="textSecondary">
                        Thank you for being a guest of the {app.club.name}. If you are having issues, please contact support at {app.club.support_email}
                    </Typography>
                </Fragment>
            }
            {(membership && membership.is_member && membership.in_good_standing) &&
                <Fragment>
                    <div className={classes.membershipIconContainer}>
                        <MembershipGoodIcon className={classes.membershipGoodIcon}/>
                    </div>
                    <Typography variant="subtitle2" component="h3" align="center" gutterBottom>
                        Your membership is in
                        <Typography variant="inherit" display="inline" className={classes.textSuccess} component="span">
                            &nbsp;good&nbsp;
                        </Typography>
                        standing.
                    </Typography>
                    {membership.is_membership_paid ? (
                        <Fragment>
                            <Typography variant="subtitle2" gutterBottom color="textSecondary">
                                You have no membership dues to pay at this time. Memberships {membership.renews_on && "renew on " + membership.renews_on + " and "}may be paid <Link color="secondary" component={RouterLink} to="/membership">here</Link> or by check.

                            </Typography>
                            <Typography variant="subtitle2" color="textSecondary">
                                You may also save a card on your <Link component={RouterLink} color="secondary" to="/membership">membership page</Link> to expedite membership invoice payments in the future.
                            </Typography>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Typography variant="subtitle2" gutterBottom>
                                Your membership is due for payment at this time. You may pay your dues <Link component={RouterLink} color="secondary" to="/membership">here</Link> or by mailing a check.
                            </Typography>
                            <Typography variant="subtitle2" color="textSecondary">
                                You may be charged an additional late fee if you have not paid in full on or before <strong>{membership.due_on}</strong>.
                            </Typography>
                        </Fragment>
                    )}
                </Fragment>
            }
            {(membership && membership.is_member && !membership.in_good_standing) &&
                <Fragment>
                    <div className={classes.membershipIconContainer}>
                        <MembershipBadIcon className={classes.membershipBadIcon}/>
                    </div>
                    <Typography variant="subtitle2" color="textSecondary" component="h3" align="center">
                        Your membership is in
                        <Typography variant="inherit" color="error" display="inline" component="span">
                            &nbsp;bad&nbsp;
                        </Typography>
                        standing.
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        Membership payment was due on or before
                        <Typography variant="subtitle2" color="error" display="inline" component="span">
                            &nbsp;{membership.due_on}&nbsp;
                        </Typography>.
                    </Typography>
                </Fragment>
            }
            {(membership.is_member) &&
                <div className={classes.bottomLink}>
                    <Link color="secondary" component={RouterLink} to="/membership">View Your Membership</Link>
                </div>
            }
        </div>
    )
}
